import Uploader from './uppyUpload';

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file); // 读取为 base64
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export function isFormatFile(file, types) {
  const allowedExtensions = types;
  const fileName = file.name.toLowerCase();

  return allowedExtensions.some((ext) => fileName.endsWith(ext));
}

// 文件后缀
export function fileExtension(name) {
  const fileName = name.toLowerCase();
  const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

  return extension;
}

// aws 上传文件
export function uploadFile(file, type) {
  const fileExtension = file.name.split('.').pop();
  return new Promise((reslove, reject) => {
    const upload = new Uploader(type, { ext: fileExtension });
    upload.onComplete = async (result) => {
      reslove(result);
    };
    upload.uploadFileWithSlice(file);
  });
}

// base64转文件对象
export function base64ToFile(base64, filename) {
  // 拆分出 mime 和数据部分
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1]; // 例如 "image/png"
  const bstr = atob(arr[1]); // 解码 base64
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

// blob转文件对象
export function blobToFile(blob, fileName) {
  return new File([blob], fileName, {
    type: blob.type,
    lastModified: Date.now(),
  });
}

export async function blobUrlToFile(blobUrl, fileName) {
  const res = await fetch(blobUrl);
  const blob = await res.blob();
  return new File([blob], fileName, { type: blob.type });
}

export function canvasToBase64(canvasId) {}
